"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const router_1 = require("@angular/router");
const app_service_1 = require("../../commons/app.service");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const ui_manager_service_1 = require("@src/app/xs/services/ui/ui-manager.service");
const core_1 = require("@ngx-translate/core");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const acl_service_1 = require("@src/app/commons/acl/acl.service");
// generic helpers
const Constants_1 = require("./../../commons/Constants");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
class SettingsComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, router, snackBar, dialog, activeRoute, translate, uiManager, permissions, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.activeRoute = activeRoute;
        this.translate = translate;
        this.uiManager = uiManager;
        this.permissions = permissions;
        /*
           this.sub = this.fourD.aa().subscribe(s =>
               this.apis = this.fourD.apis.filter(ap => ap.account.id == this.fourD.aa.id)
        )
        */
    }
    onReady() {
        // hack for old qMap upload
        this.fourD.activeTeam['V'] = this.fourD.activeTeam.vasat;
        // hide HangOn / waiting box (if open)
        Constants_1.Constants.hideHangOn();
        /*
        this.apis = this.fourD.apis.filter(ap => ap.account.id == this.fourD.aa.id)
        this.fourD.aa.accountGroups.queryObservable().subscribe(res => this.groups = res.items)
        */
    }
    saveCurrentAccount() {
        var okMsg;
        var errMsg;
        this.translate.get(['SETTINGS.ACC_SAVE_OK', 'SETTINGS.ACC_SAVE_ERR']).pipe(operators_1.mergeMap(params => {
            okMsg = params['SETTINGS.ACC_SAVE_OK'];
            errMsg = params['SETTINGS.ACC_SAVE_ERR'];
            return this.fourD.activeTeam.saveObservable();
        })).subscribe(res => {
            this.openSnackBarSuccess(okMsg);
        }, err => {
            this.openSnackBarSuccess(errMsg);
        });
    }
    // delete the account
    /*deleteCurrentAccount() {
      this.openDialogWithMeta({deletename: this.fourD.account.name + ' Account'} , 'GENERIC.DIALOG.DELETE.TITLE', 'GENERIC.DIALOG.DELETE.MSG', 'GENERIC.YES', 'GENERIC.NO').subscribe(s => {
        if (s) {
          this.fourD.account.destroyObservable().subscribe(_ => {
            this.service.V.logoutObservable().subscribe(
              succ => {
                this.fourD.clearStates()
                // Go to root page on logout
                this.router.navigateByUrl(AppRoutes.AUTH)
              },
              err => {
                this.openSnackBarError(err);
              }
            )
          }, error1 => {
            this.openSnackBarError('Error while deleting the account, please ensure you delete your projects and data.');
          });
        }
      });
    }*/
    uploadFile(event) {
        this.loading = true;
        let fileList = event.target.files;
        if (fileList.length > 0) {
            let file = fileList[0];
            fetch(this.fourD.V.config.host + "/api/Account/" + this.fourD.activeTeam.id + '/image.png', {
                method: 'POST',
                body: file,
                headers: {
                    'Content-type': 'application/binary',
                    Authorization: 'bearer ' + this.service.V.authToken()
                }
            }).then(r => {
                this.loading = false;
                // Reload the img src after file uplaoded to server
                this.imageDirective.updateLink();
            });
        }
        else {
            this.loading = false;
        }
    }
}
exports.SettingsComponent = SettingsComponent;
